
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dynamicplusextra",
      function () {
        return require("private-next-pages/dynamicplusextra.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dynamicplusextra"])
      });
    }
  